import { CurrencyAmount } from '~/utils/CurrencyAmount'

/** The gratuity for a percentage of a subtotal, rounded to the currency's minor unit. */
export function tipAmountForPercent(subtotal: number | string, percent: number): number {
  const minor = CurrencyAmount.minorUnits(CurrencyAmount.defaultCurrency)
  return Number(((Number.parseFloat(String(subtotal)) * percent) / 100).toFixed(minor))
}
